import React from "react";

import HeroSection from "../components/home/HeroSection";
import AboutSection from "../components/home/AboutSection";
import FeaturedCakes from "../components/home/FeaturedCakes";
import TestimonialsPreview from "../components/home/TestimonialsPreview";
import CtaSection from "../components/home/CtaSection";
import { realisations, testimonials } from "../data/mock";

const HomePage = () => {
  const featuredCakes = realisations.slice(0, 3);
  const featuredTestimonials = testimonials.slice(0, 3);

  return (
    <div>
      <HeroSection />
      <AboutSection />
      <FeaturedCakes cakes={featuredCakes} />
      <TestimonialsPreview testimonials={featuredTestimonials} />
      <CtaSection />
    </div>
  );
};

export default HomePage;
